

<template>
  <div>
    <section class="menu-btn">
      <button class="resp-menu-btn bg-none pt-3">
        <div class="menu-svg menu-svg1"></div>
        <div class="menu-svg menu-svg2"></div>
        <div class="menu-svg3"></div>
      </button>
    </section>

  </div>

</template>

<script>
export default {
  name: "MenuBtn",
  components:{
  },
  methods:{

  }
}
</script>

<style scoped>
/*.menu-btn{*/
/*  position: relative;*/
/*  z-index:0;*/
/*}*/
/*.resp-menu-btn{*/
/*  position: fixed;*/
/*  left: 30px;*/
/*  top: 30px;*/
/*  z-index: 2000;*/

/*}*/
.menu-svg{
  height: 4px;
  width: 35px;
  background-color: white;
  margin-bottom: 6px;
  border-radius: 2px;
}
.menu-svg2{
  transition: .5s;
}
.menu-svg3{
  height: 4px;
  width: 35px;
  background-color: white;
  border-radius: 2px;

}
.close-btn .menu-svg3{
  opacity: 0;
  pointer-events: none;
  transition: .5s;
}
.close-btn .menu-svg2{
  transform: rotate(45deg) translate(-1px , -2px);
}
.close-btn .menu-svg1{
  transform: rotate(-45deg) translate(-5px , 6px);

}
</style>